// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__1blLa","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__zOvja"};